"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SKFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_208)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_208`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.67993 0.000244141H31.3201V23.9998H-4.67993V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.67993 7.82642H31.3201V16.1737H-4.67993V7.82642Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.67993 16.1736H31.3201V23.9997H-4.67993V16.1736Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.42328 6.78271V12.7688C4.42328 16.174 8.87174 17.2173 8.87174 17.2173C8.87174 17.2173 13.3201 16.1739 13.3201 12.7688V6.78271H4.42328Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.59454 6.95825V12.7197C5.59454 13.1045 5.67997 13.4679 5.84928 13.8085H11.8941C12.0634 13.4679 12.1488 13.1046 12.1488 12.7197V6.95825H5.59454Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.8803 10.9753H9.37386V9.97102H10.3782V8.96675H9.37386V7.9624H8.36958V8.96675H7.36538V9.97102H8.36958V10.9753H6.86307V11.9796H8.36958V12.9839H9.37386V11.9796H10.8803V10.9753Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.21921 15.2104C7.86636 15.617 8.53124 15.8533 8.87169 15.9583C9.21215 15.8532 9.87702 15.6171 10.5242 15.2104C11.1768 14.8003 11.6344 14.3311 11.8941 13.8085C11.5979 13.5984 11.2436 13.4858 10.8804 13.4862C10.7429 13.4862 10.6093 13.5025 10.4809 13.5324C10.2087 12.9139 9.59085 12.4819 8.87183 12.4819C8.15275 12.4819 7.53498 12.9139 7.2628 13.5324C7.13183 13.5018 6.99778 13.4863 6.86328 13.4862C6.50011 13.4858 6.1458 13.5984 5.84952 13.8085C6.10904 14.3311 6.56657 14.8003 7.21921 15.2104Z",
					fill: "#0052B4"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_208`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SKFlag };
